import { connect } from 'react-redux'
import { pauseNewsTicker, resumeNewsTicker } from 'redux/actions'
import NewsTickerControlButton from 'pages/dashboard/NewsTickerControlButton'

const mapStateToProps = (state) => ({
  paused: state.newsTicker.paused,
  deviceType: state.layout.deviceType,
  isTouchDevice: state.layout.isTouchDevice
})

const mapDispatchToProps = dispatch => ({
  pauseNewsTicker: () => dispatch(pauseNewsTicker()),
  resumeNewsTicker: () => dispatch(resumeNewsTicker())
})

export default connect(mapStateToProps, mapDispatchToProps)(NewsTickerControlButton)
